import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icons from '@components/Icons';
import { Paragraph, Subtitle } from '../Styled';
import { AlertWrapper, ChildrenWrapper, InfoWrapper } from './Alert.style';
const alertTypes = {
    ERROR: {
        icon: _jsx(Icons.ExclamationTriangle, {})
    },
    INFO: {
        icon: _jsx(Icons.InformationCircle, {})
    },
    SUCCESS: {
        icon: _jsx(Icons.PaperAirplane, {})
    },
    WARNING: {
        icon: _jsx(Icons.ExclamationTriangle, {})
    }
};
const Alert = (props) => {
    const { alertType = 'INFO', isIconVisible = true, title, message, children } = props;
    return (_jsxs(AlertWrapper, { alertType: alertType, children: [isIconVisible && (_jsx("div", { children: alertTypes[alertType].icon })), _jsxs(InfoWrapper, { hasChildren: Boolean(children), children: [title && (_jsx(Subtitle, { children: title })), _jsx(Paragraph, { children: message }), children && (_jsx(ChildrenWrapper, { children: children }))] })] }));
};
export default Alert;
